<app-page [title]="'Order No. ' + (order$ | async)?.id" [isLoading]="isLoading$ | async" [error]="error$ | async">
  <div *ngIf="(order$ | async)?.status" slot="title" class="mt-2 ml-5" data-cy="order-status">
    <app-order-status-tag [orderStatus]="(order$ | async)?.status!"></app-order-status-tag>
  </div>
  <div class="grid">
    <div
      class="col-12"
      [ngClass]="{ 'lg:col-8': (order$ | async)?.isShipped || (order$ | async)?.detailedStatus?.length }"
    >
      <p-card data-cy="order-summary-widget">
        <h2 class="mt-0 mb-3">Order Summary</h2>
        <div class="table-full-card-container">
          <p-table [value]="(order$ | async)?.items || []" responsiveLayout="stack">
            <ng-template pTemplate="header">
              <tr>
                <th data-cy="order-products-title-header">Product</th>
                <th data-cy="order-products-quantity-header">Qty</th>
                <th data-cy="order-products-category-header">Category</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr data-cy="order-products-item">
                <td data-cy="order-products-item-title">
                  <span class="p-column-title" data-cy="order-products-title-header">Product</span
                  >{{ item.description }}
                </td>
                <td data-cy="order-products-item-quantity">
                  <span class="p-column-title" data-cy="order-products-quantity-header">Qty</span>{{ item.quantity }}
                </td>
                <td data-cy="order-products-item-category">
                  <span class="p-column-title" data-cy="order-products-category-header">Category</span
                  >{{ item.category }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-card>

      <!-- Show customer widget here in desktop view -->
      <div class="hidden lg:block">
        <ng-container *ngTemplateOutlet="customerDetailsWidget"></ng-container>
      </div>
    </div>
    <div class="col-12 lg:col-4">
      <div *ngIf="(order$ | async)?.isShipped" class="mb-5">
        <p-card>
          <h2 class="mt-0 mb-5">Shipping Details</h2>

          <div class="mb-4">
            <p class="p2 font-semibold m-0">
              <span class="inline-block mr-2 date-label">Ship Date</span>
              <span class="inline-block date-value" data-cy="shipping-details-ship-date">{{
                (order$ | async)?.targetedShipDate | formatDate
              }}</span>
            </p>
          </div>
          <div *ngIf="(order$ | async)?.deliveryDate" class="mb-4">
            <p class="p2 font-semibold m-0">
              <span class="inline-block mr-2 date-label">Delivery Date</span>
              <span class="inline-block date-value" data-cy="shipping-details-ship-date">{{
                (order$ | async)?.deliveryDate | formatDate
              }}</span>
            </p>
          </div>
          <div class="text-center">
            <div *ngIf="(order$ | async)?.trackingNumberUrl">
              <img
                *ngIf="(order$ | async)?.trackingNumberUrl?.includes('ups')"
                alt="ups-logo"
                src="./assets/images/ups-logo.png"
                height="80px"
                alt="UPS Logo"
                data-cy="shipping-details-tracking-logo"
              />
              <img
                *ngIf="(order$ | async)?.trackingNumberUrl?.includes('usps')"
                alt="usps-logo"
                src="./assets/images/usps-logo.jpg"
                height="80px"
                class="my-0"
                alt="USPS Logo"
                data-cy="shipping-details-tracking-logo"
              />
              <p class="p2 mt-3 mb-1">Tracking number</p>
              <a
                href="{{ (order$ | async)?.trackingNumberUrl }}"
                target="_blank"
                data-cy="shipping-details-tracking-link"
                appClickEvent
                eventName="order_shipping_details_click_tracking_link"
              >
                {{ (order$ | async)?.trackingNumber }}
              </a>
            </div>
          </div>
        </p-card>
      </div>

      <div *ngIf="(order$ | async)?.detailedStatus?.length">
        <p-card data-cy="order-status-widget">
          <h2 class="mt-0 mb-5">Order Status</h2>
          <app-order-status-timeline
            [orderDetailedStatus]="(order$ | async)?.detailedStatus!"
          ></app-order-status-timeline>
        </p-card>
      </div>
      <!-- Show customer widget here in mobile view -->
      <div class="block lg:hidden">
        <ng-container *ngTemplateOutlet="customerDetailsWidget"></ng-container>
      </div>
    </div>
  </div>
</app-page>

<ng-template #customerDetailsWidget>
  <div class="mt-5">
    <p-card data-cy="contacts-shipping-widget">
      <h2 class="mt-0 mb-5">Customer Details</h2>
      <div>
        <h3 class="mt-0 mb-4">Shipping to</h3>
        <p class="p3" data-cy="contacts-shipping-patient-name">{{ (patient$ | async)?.fullName | titlecase }}</p>
        <p
          class="p3"
          [innerHTML]="(order$ | async)?.shippingAddress | formatAddress"
          data-cy="contacts-shipping-address"
        ></p>
      </div>
      <div
        *ngIf="(order$ | async)?.primaryInsurance || (order$ | async)?.secondaryInsurance"
        title="Insurance"
        data-cy="insurance-widget"
      >
        <h3 class="mt-6 mb-4">Insurance</h3>
        <div *ngIf="(order$ | async)?.primaryInsurance" class="mb-4">
          <h4 class="mt-0 mb-4">Primary Insurance</h4>
          <app-insurance-details [insurance]="(order$ | async)?.primaryInsurance!" data-cy="primary-insurance-details">
          </app-insurance-details>
        </div>
        <div *ngIf="(order$ | async)?.secondaryInsurance" class="mt-3">
          <h4 class="mt-0 mb-4">Secondary Insurance</h4>
          <app-insurance-details
            [insurance]="(order$ | async)?.secondaryInsurance!"
            data-cy="secondary-insurance-details"
          >
          </app-insurance-details>
        </div>
      </div>
    </p-card>
  </div>
</ng-template>
